import template from './sw-cms-preview-acris-blog-image.html.twig';
import './sw-cms-preview-acris-blog-image.scss';

const { Component } = Shopware;

Component.register('sw-cms-preview-acris-blog-image', {
    template,

    computed: {
        assetFilter() {
            return Shopware.Filter.getByName('asset');
        },
    },
});
